import { html } from 'lit';

/** Trash with a recurrence badge; the badge deliberately contains no clock. */
export const cleanupIcon = (size = 20) =>
  html`<svg
    width=${size}
    height=${size}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M3 6h14M7 6V3h6v3M5 6l1 14h7M9 10v6M12 10v3"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
    <circle
      cx="18"
      cy="18"
      r="5.5"
      fill="var(--streamlain-v2-layer-background-primary, #fff)"
    ></circle>
    <path
      d="M15.5 17a3 3 0 0 1 5-.8l.6.8M21.1 14.9v2.2h-2.2M20.5 19a3 3 0 0 1-5 .8l-.6-.8M14.9 21.1v-2.2h2.2"
      stroke="currentColor"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
  </svg>`;
